import { render } from "./RightWayReviewProcess.vue?vue&type=template&id=8a2e18ba"
import script from "./RightWayReviewProcess.vue?vue&type=script&lang=ts"
export * from "./RightWayReviewProcess.vue?vue&type=script&lang=ts"
script.render = render

export default script